import { render } from "./DuncePlaceholder.vue?vue&type=template&id=efe4e5fa"
import script from "./DuncePlaceholder.vue?vue&type=script&lang=js"
export * from "./DuncePlaceholder.vue?vue&type=script&lang=js"

import "./DuncePlaceholder.vue?vue&type=style&index=0&id=efe4e5fa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__